export const TEAMS = {
  SALES: { id: 'sales', name: 'Vendas', color: 'bg-emerald-100 text-emerald-700', border: 'border-emerald-200' },
  SUPPORT: { id: 'support', name: 'Suporte', color: 'bg-sky-100 text-sky-700', border: 'border-sky-200' },
  FINANCE: { id: 'finance', name: 'Financeiro', color: 'bg-amber-100 text-amber-700', border: 'border-amber-200' }
};
